import { render, staticRenderFns } from "./playground.vue?vue&type=template&id=0ca7a06e&scoped=true&"
import script from "./playground.vue?vue&type=script&lang=js&"
export * from "./playground.vue?vue&type=script&lang=js&"
import style0 from "./playground.vue?vue&type=style&index=0&id=0ca7a06e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca7a06e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Topbar: require('/opt/build/repo/components/Topbar.vue').default,SideMenuPlayground: require('/opt/build/repo/components/SideMenuPlayground.vue').default,Footer: require('/opt/build/repo/components/Footer.vue').default,RightSidebar: require('/opt/build/repo/components/Right-sidebar.vue').default})
